import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate
} from "react-router-dom";
import { jwtDecode } from "jwt-decode"; // ✅ ADDED

import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import Leaves from "./components/Leaves/Leaves";
import Dashboard from "./components/Dashboard";
import LeaveTypes from "./components/Leaves/LeaveTypes";
import Clients from "./components/Clients/Clients";
import Projects from "./components/Projects/Projects";
import ProjectTypes from "./components/Projects/ProjectTypes";
import Employee from "./components/Employee/Employee";
import Departments from "./components/Employee/Departments";
import Designations from "./components/Employee/Desinations";
import Attendence from "./components/Attendance/AttendancePage";
import AttendanceReport from "./components/Attendance/AttendanceReport";
import TimesheetsPage from "./components/Attendance/Timesheets";
import PaySlipsDashboard from "./components/Employeeportal/Payrolls/PaySlipsDashboard";
import Login from "./components/Login";
import ProtectedRoute from "./config/ProtectedRoute";

import PayrollOverview from "./components/Payrolls/Payroll";
import Holiday from "./components/Holidays/Holiday";
import Role from "./components/Roles/Role";
import TasksPage from "./components/TasksPages/TasksPage";
import Work from "./components/WorkTime/Work";
import EmployeeWork from "./components/WorkTime/EmployeeWork";
import RequestManagement from "./components/RequestManagement/RequestManagement";
import TasksRequestsDashboard from "./components/TasksRequestsDashboard/TasksRequestsDashboard";
import PolicyCategoryManagement from "./components/Policies/PolicyCategoryManagement";
import PolicyManagement from "./components/Policies/PolicyManagement";
import AnnouncementManagement from "./components/Announcements/AnnouncementManagement";
import Letters from "./components/Letters/Letters";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import OTPVerification from "./components/OTPVerification";
import ChangePassword from "./components/Settings/ChangePassword";
import Profile from "./components/Profile";
import KanbanBoard from "./components/TasksPages/Kanban board";
import ScrollToTop from "./components/ScrollToTop";
import Calendarview from "./components/Attendance/Calendarview";
import CalendarView from "./components/Attendance/Calendarview";
import AssetManagementModule from "./components/AssetsManagement/AssetManagement";
import AssetTypesModule from "./components/AssetsManagement/Assettypesmodule";
import AssetCategoryModule from "./components/AssetsManagement/Assetcategorymodule";
import Workplacelssues from "./components/Complaints/Workplacelssues"
import ManagerDashboard from "./components/Manager/Managerdashboard";
import WorkplaceDocuments from "./components/Workplacedocuments";

import BonusTypes from "./components/Payrolls/BonusTypes";
import DocumentTypes from "./components/DocumentTypes";
import Certificates from "./components/Certifications/Certificates";
import OrganizationChart from "./components/Organization/Organizationchart";
import LeaveCarryForward from "./components/Leaves/Leavecarryforward";
import AdminProjectInsights from "./components/Projects/proj";
import WorkplaceIssuesCategory from "./components/Complaints/WorkplaceIssuesCategory";
import Recruitmentmanagement from "./components/Resume/Recruitmentmanagement";
import AuditLogs from "./components/Logs/AuditLogs";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// ======================================================
// ✅ TOKEN EXPIRY HANDLER (ADDED INSIDE App.js)
// ======================================================
const TokenExpiryHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const decoded = jwtDecode(token);

      // Store expiry so your ProtectedRoute can read it
      localStorage.setItem("token_expiry", decoded.exp);

      const remainingTime = decoded.exp * 1000 - Date.now();

      if (remainingTime <= 0) {
        localStorage.clear();
        navigate("/", { replace: true });
        return;
      }

      const timer = setTimeout(() => {
        localStorage.clear();
        navigate("/", { replace: true });
      }, remainingTime);

      return () => clearTimeout(timer);
    } catch (error) {
      localStorage.clear();
      navigate("/", { replace: true });
    }
  }, [navigate]);

  return null;
};


// ======================================================
// Layout wrapper component (UPDATED FOR TABLET BEHAVIOR)
// ======================================================
function AppLayout({ children }) {
  const location = useLocation();
  const noSidebarPages = [
    "/",
    "/login",
    "/ForgotPassword",
    "/ResetPassword",
    "/OTPVerification"
  ];
  const hideLayout = noSidebarPages.includes(location.pathname);

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [sidebarVisible, setSidebarVisible] = useState(false);

  // Prevent going back after logout
  useEffect(() => {
    const handlePopState = () => {
      const token = localStorage.getItem("token");
      if (!token) window.history.go(1);
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  // Screen size handling - UPDATED TO TREAT TABLET LIKE MOBILE
  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      const mobile = width < 768;
      const tablet = width >= 768 && width < 1024;

      setIsMobile(mobile);
      setIsTablet(tablet);

      // Treat both mobile and tablet the same way - hidden by default
      if (mobile || tablet) {
        setSidebarCollapsed(false);
        setSidebarVisible(false); // Hidden by default for both mobile and tablet
      } else {
        // Desktop behavior
        setSidebarCollapsed(false);
        setSidebarVisible(true);
      }
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const toggleSidebar = () => {
    // Both mobile and tablet should toggle visibility, not collapse state
    if (isMobile || isTablet) {
      setSidebarVisible(!sidebarVisible);
    } else {
      // Desktop toggles collapse state
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };

  const closeSidebar = () => {
    // Close sidebar for both mobile and tablet
    if (isMobile || isTablet) {
      setSidebarVisible(false);
    }
  };

  if (hideLayout) {
    return <div className="w-full h-screen">{children}</div>;
  }

  return (
    <>
    <ScrollToTop />
    <div className="box-border flex p-0 m-0 w-full min-h-screen bg-sky-50">
      <div className="box-border flex relative p-0 m-0 w-full">
        {/* Overlay for both mobile and tablet */}
        {(isMobile || isTablet) && sidebarVisible && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-[999]"
            onClick={closeSidebar}
          />
        )}

        <Sidebar
          collapsed={sidebarCollapsed}
          visible={sidebarVisible}
          isMobile={isMobile}
          isTablet={isTablet}
          onToggle={toggleSidebar}
          onClose={closeSidebar}
        />

        <main
          className={`box-border p-0 m-0 min-h-screen bg-sky-50 transition-all duration-300 w-full ${
            // Only apply margin/width adjustments for desktop when sidebar is visible
            !isMobile && !isTablet && sidebarVisible
              ? sidebarCollapsed
                ? "lg:ml-16 lg:w-[calc(100%-64px)]"
                : "lg:ml-64 lg:w-[calc(100%-256px)]"
              : ""
          }`}
        >
          <Header
            onMenuClick={toggleSidebar}
            sidebarCollapsed={sidebarCollapsed}
            isMobile={isMobile}
            isTablet={isTablet}
          />

          <div className="box-border p-0 m-0 w-full">{children}</div>
        </main>
      </div>
    </div>
    </>
  );
}


// ======================================================
// App Component (ONLY ONE LINE ADDED)
// ======================================================
function App() {
  return (
    <>
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;600;700&family=Lato:wght@400;600;700&family=Noto+Sans:wght@400;700&family=Inter:wght@600;700&family=Poppins:wght@400;500;600;700&display=swap"
      />
      {/* 🔥 TOKEN EXPIRY HANDLER */}
      <TokenExpiryHandler />

      <AppLayout>

        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/ForgotPassword" element={<ForgotPassword />} />
          <Route path="/ResetPassword" element={<ResetPassword />} />
          <Route path="/OTPVerification" element={<OTPVerification />} />

          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/leaves" element={<ProtectedRoute><Leaves /></ProtectedRoute>} />
          <Route path="/leaveTypes" element={<ProtectedRoute><LeaveTypes /></ProtectedRoute>} />
          <Route path="/client" element={<ProtectedRoute><Clients /></ProtectedRoute>} />
          <Route path="/Project" element={<ProtectedRoute><Projects /></ProtectedRoute>} />
          <Route path="/ProjectTypes" element={<ProtectedRoute><ProjectTypes /></ProtectedRoute>} />
          <Route path="/Employee" element={<ProtectedRoute><Employee /></ProtectedRoute>} />
          <Route path="/Departments" element={<ProtectedRoute><Departments /></ProtectedRoute>} />
          {/* <Route path="/Attendence" element={<ProtectedRoute><Attendence /></ProtectedRoute>} /> */}
          <Route path="/AttendenceReport" element={<ProtectedRoute><AttendanceReport /></ProtectedRoute>} />
          <Route path="/TimeSheet" element={<ProtectedRoute><TimesheetsPage /></ProtectedRoute>} />
          <Route path="/Designations" element={<ProtectedRoute><Designations /></ProtectedRoute>} />
          <Route path="/payroll" element={<ProtectedRoute><PaySlipsDashboard /></ProtectedRoute>} />
          <Route path="/payrolls" element={<ProtectedRoute><PayrollOverview /></ProtectedRoute>} />
          <Route path="/Holidays" element={<ProtectedRoute><Holiday /></ProtectedRoute>} />
          <Route path="/Roles" element={<ProtectedRoute><Role /></ProtectedRoute>} />
          <Route path="/task" element={<ProtectedRoute><KanbanBoard /></ProtectedRoute>} />
          <Route path="/Work" element={<ProtectedRoute><Work /></ProtectedRoute>} />
          {/* <Route path="/task" element={<TasksPage />} /> */}
          <Route path="/employeework" element={<ProtectedRoute><EmployeeWork /></ProtectedRoute>} />
          <Route path="/RequestManagement" element={<ProtectedRoute><RequestManagement /></ProtectedRoute>} />
          <Route path="/TasksRequestsDashboard" element={<ProtectedRoute><TasksRequestsDashboard /></ProtectedRoute>} />
          <Route path="/PolicyCategory" element={<ProtectedRoute><PolicyCategoryManagement /></ProtectedRoute>} />
          <Route path="/PolicyManagement" element={<ProtectedRoute><PolicyManagement /></ProtectedRoute>} />
          <Route path="/AnnouncementManagement" element={<ProtectedRoute><AnnouncementManagement /></ProtectedRoute>} />
          <Route path="/letters" element={<ProtectedRoute><WorkplaceDocuments /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/Attendence" element={<ProtectedRoute><CalendarView/></ProtectedRoute>} />
          <Route path="/AssetsManagement" element={<ProtectedRoute><AssetManagementModule/></ProtectedRoute>} />
          <Route path="/AssetType" element={<ProtectedRoute><AssetTypesModule/></ProtectedRoute>} />
          <Route path="/CategoryType" element={<ProtectedRoute><AssetCategoryModule/></ProtectedRoute>} />
          <Route path="/Workplacelssues" element={<ProtectedRoute><Workplacelssues/></ProtectedRoute>} />
          <Route path="/Workplacedoc" element={<ProtectedRoute><WorkplaceDocuments/></ProtectedRoute>} />
          <Route path="/ManagerDashboard" element={<ProtectedRoute><ManagerDashboard/></ProtectedRoute>} />
          <Route path="/BonusTypes" element={<ProtectedRoute><BonusTypes/></ProtectedRoute>} />
          <Route path="/DocumentTypes" element={<ProtectedRoute><DocumentTypes/></ProtectedRoute>} />
          <Route path="/Certificates" element={<ProtectedRoute><Certificates/></ProtectedRoute>} />
          <Route path="/OrganizationChart" element={<ProtectedRoute><OrganizationChart/></ProtectedRoute>} />
          <Route path="/LeaveCarryForward" element={<ProtectedRoute><LeaveCarryForward/></ProtectedRoute>} />
          <Route path="/ProjectInsights" element={<ProtectedRoute><AdminProjectInsights/></ProtectedRoute>} />
          <Route path="/WorkplaceIssuesCategory" element={<ProtectedRoute><WorkplaceIssuesCategory/></ProtectedRoute>} />
          <Route path="/Recruitmentmanagement" element={<ProtectedRoute><Recruitmentmanagement/></ProtectedRoute>} />
          <Route path="/audit-logs" element={<ProtectedRoute><AuditLogs/></ProtectedRoute>} />
         
          

        </Routes>
      </AppLayout>
      {/* <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      /> */}
    </>
  );
}

export default App;
